import { microCopy } from "@bmi-digital/dxb-microcopies";
import React from "react";
import { useTheme } from "@mui/material/styles";
import { useSiteContext } from "../../../components/Site";
import { trainingCategoryMicroCopies } from "../../../constants/trainingCategoryMicroCopies";
import { trainingTypeMicroCopies } from "../../../constants/trainingTypeMicroCopies";
import { getPriceLabel } from "../../../utils/trainingUtils";
import getCategoryType from "../../../utils/getCategoryType";
import { StyledTrainingCard } from "../trainingDetailsPageStyles";
import useTrainingDetailsImage from "../hooks/useTrainingDetailsImage";
import type { TrainingDetailsCourseType as Course } from "../types";
import type { ImageTrainingDetail } from "../../../components/image/types";

export type DesktopTrainingCardProps = Pick<
  Course,
  | "name"
  | "categoryName"
  | "code"
  | "price"
  | "currencySymbol"
  | "course_type"
  | "img_url"
> & {
  sessionsContainerId: string;
  fallbackImageData: ImageTrainingDetail | null;
};

const DesktopTrainingCard = ({
  name,
  code,
  price,
  currencySymbol,
  categoryName,
  course_type,
  img_url,
  sessionsContainerId,
  fallbackImageData
}: DesktopTrainingCardProps) => {
  const { getMicroCopy } = useSiteContext();
  const theme = useTheme();
  const media = useTrainingDetailsImage({
    courseName: name,
    courseImageUrl: img_url,
    fallbackImageData,
    theme
  });
  const availableSessionButtonLabel = getMicroCopy(
    microCopy.TRAINING_DETAILS_SEE_AVAILABLE_SESSIONS_BUTTON
  );
  const href = `#${sessionsContainerId}`;

  return (
    <StyledTrainingCard
      title={name}
      subtitle={`${getMicroCopy(microCopy.TRAINING_CODE_LABEL)} ${code}`}
      media={media}
      price={getPriceLabel(
        price,
        currencySymbol,
        getMicroCopy(microCopy.TRAINING_PRICE_FREE)
      )}
      category={{
        type: getCategoryType(categoryName),
        // eslint-disable-next-line security/detect-object-injection
        label: getMicroCopy(trainingCategoryMicroCopies[categoryName])
      }}
      trainingType={{
        type: course_type,
        // eslint-disable-next-line security/detect-object-injection
        label: getMicroCopy(trainingTypeMicroCopies[course_type])
      }}
      ctaLabel={availableSessionButtonLabel}
      href={href}
      gtm={{
        id: "cta-click1",
        label: availableSessionButtonLabel,
        action: href
      }}
    />
  );
};

export default DesktopTrainingCard;
